import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PanelComponent } from '../../../../common/modules/panel/panel.component';

@Component({
    template: `
        <div id="backgrounded" class="container-fluid h-100">
            <div class="row align-items-center h-100">
                <div class="offset-md-2 col-md-8 offset-lg-3 col-lg-6 offset-xxl-4 col-xxl-4">
                    <app-panel class="p-5">
                        <router-outlet/>
                    </app-panel>
                </div>
            </div>
        </div>
    `,
    imports: [
        RouterModule,
        PanelComponent,
    ],
})
export class RootComponent {}
